import { useFormik } from "formik";
import { useState } from "react";
import {
  OpretFirmaStep1Formik,
  OpretFirmaStep2Formik,
} from "../opretFirmaInterface";
import { ISeptimaSearchResultItem } from "../../../SeptimaSearchReact/interfaces/types";
import { useMutation } from "@tanstack/react-query";
import { post } from "../../../../api/util";
import {
  opretFirmaStep2InitialState,
  opretFirmaStep1InitialState,
} from "../opretFirmaState";
import { step1Validation } from "../steps/step1/step1ValidationSchema";
import { getOpretDKFirmaDTO } from "./dto/getOpretDKFirmaDTO";
import { getOpretUDLFirmaDTO } from "./dto/getOpretUDLFirmaDTO";
import { step2Validation } from "../steps/step2/step2ValidationSchema";
import { getOpretFOFirmaDTO } from "./dto/getOpretFOFirmaDTO";
import { IProduktionsenhed } from "../../../../interfaces/firma";

export const useOpretFirma = () => {
  const [step, setStep] = useState(1);
  const [searchResult, setSearchResult] = useState<
    ISeptimaSearchResultItem | undefined
  >(undefined);
  const [produktionsEnheder, setProduktionsEnheder] = useState<
    IProduktionsenhed[]
  >([]);
  const step1 = useFormik<OpretFirmaStep1Formik>({
    validateOnMount: true,
    validateOnChange: true,
    enableReinitialize: true,
    initialValues: opretFirmaStep1InitialState,
    validationSchema: step1Validation,
    onSubmit: () => setStep(2),
  });
  const step2 = useFormik<OpretFirmaStep2Formik>({
    validateOnMount: true,
    validateOnChange: true,
    enableReinitialize: true,
    initialValues: opretFirmaStep2InitialState,
    validationSchema: step2Validation(step1.values),
    onSubmit: () => {
      opretFirmaQuery.mutate({ step1: step1.values, step2: step2.values });
      setStep(3);
    },
  });
  const opretFirmaQuery = useMutation({
    mutationFn: async (form: {
      step1: OpretFirmaStep1Formik;
      step2: OpretFirmaStep2Formik;
    }) => {
      const query = "firma";
      const code = form.step1.land;
      switch (code) {
        case "DK": {
          const body = await getOpretDKFirmaDTO(form);
          setSearchResult(undefined);
          return post<PostResult>({
            query,
            body,
          });
        }
        case "GL": {
          const body = await getOpretDKFirmaDTO(form);
          setSearchResult(undefined);
          return post<PostResult>({
            query,
            body,
          });
        }
        case "FO": {
          const body = getOpretFOFirmaDTO(form);
          setSearchResult(undefined);
          return post<PostResult>({
            query,
            body,
          });
        }
        case "UDL": {
          const body = getOpretUDLFirmaDTO(form);
          setSearchResult(undefined);
          return post<PostResult>({
            query,
            body,
          });
        }
        default:
          throw new Error("Unknown value " + form.step1.land);
      }
    },
  });

  return {
    step,
    setStep,
    step1,
    step2,
    searchResult,
    setSearchResult,
    produktionsEnheder,
    setProduktionsEnheder,
    opretFirmaQuery,
  };
};

type PostResult = { id: string; navn1: string };
